import { Auth } from 'aws-amplify';

const getUser = () => {
  return Auth.currentAuthenticatedUser();
};

export default getUser;
